import React, { useEffect, useState, useRef } from "react";
import Footer from "../Header/Footer";
import Header from "../Header/Header";
import Config from "../Header/Config";
import { FaTrash, FaTrashAlt, FaEdit } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import Supplier_pagination from "../Header/Supplier_pagination";
import { useNavigate } from 'react-router-dom';

export default function Purchase() {
  const [imeiNotFound, setImeiNotFound] = useState(false);
  const today = new Date().toISOString().split("T")[0];
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [date, setDate] = useState(today);
  const [supplierName, setSupplierName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [address, setAddress] = useState("");

  let [modelName, setModelName] = useState("");
  let [modelName1, setModelName1] = useState("");
  const [imei, setImei] = useState("");
  const [price, setPrice] = useState("");
  const [quantity, setQuantity] = useState("");
  const [color, setColor] = useState("");

  let [subTotal, setSubTotal] = useState(0);
  let [balance, setBalance] = useState(0);

  let [payableAmount, setPayableAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [file, setFile] = useState(null);





  const [tableData, setTableData] = useState([]);
  const [editIndex, setEditIndex] = useState(null); // Track which Brand Details item is being edited

  const [shouldFetchData, setShouldFetchData] = useState(false);
  const [supplierPaginationRefreshKey, setSupplierPaginationRefreshKey] = useState(0);

  const apiUrl = Config.apiUrl;

  const capitalizeWords = (str) => {
    if (!str) return '';
    return str
      .toString()
      .split(/\s+/)
      .map((w) => (w.length > 0 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ''))
      .join(' ');
  };

  // Validation functions
  const validateInvoiceNumber = (value) => {
    // Convert to string if it's a number
    const strValue = value ? value.toString() : "";
    if (!value || strValue.trim() === "") {
      return "Invoice number is required";
    }
    if (!/^\d+$/.test(strValue.trim())) {
      return "Invoice number must contain only digits";
    }
    return "";
  };

  const validateDate = (value) => {
    const strValue = value ? value.toString() : "";
    if (!value || strValue.trim() === "") {
      return "Date is required";
    }
    const selectedDate = new Date(value);
    selectedDate.setHours(0, 0, 0, 0);
    const todayDate = new Date();
    todayDate.setHours(0, 0, 0, 0);
    if (selectedDate > todayDate) {
      return "Date cannot be in the future";
    }
    return "";
  };

  const validateSupplierName = (value) => {
    // Convert to string if needed
    const strValue = value ? value.toString() : "";
    if (!value || strValue.trim() === "") {
      return "Supplier name is required";
    }
    if (strValue.trim().length < 2) {
      return "Supplier name must be at least 2 characters";
    }
    if (strValue.trim().length > 100) {
      return "Supplier name must not exceed 100 characters";
    }
    return "";
  };

  const validateMobileNumber = (value) => {
    // Convert to string if needed
    const strValue = value ? value.toString() : "";
    if (!value || strValue.trim() === "") {
      return "Mobile number is required";
    }
    if (!/^\d+$/.test(strValue)) {
      return "Mobile number must contain only digits";
    }
    if (strValue.length !== 10) {
      return "Mobile number must be exactly 10 digits";
    }
    return "";
  };

  // Brand Details validation
  const validateBrandDetails = () => {
    const errors = {};
    const modelName1Str = modelName1 ? modelName1.toString() : "";
    const colorStr = color ? color.toString() : "";
    const imeiStr = imei ? imei.toString() : "";
    const quantityStr = quantity ? quantity.toString() : "";
    
    if (!modelName1 || modelName1Str.trim() === "") {
      errors.modelName1 = "Model name is required";
    }
    if (!color || colorStr.trim() === "") {
      errors.color = "Color is required";
    }
    if (!imei || imeiStr.trim() === "") {
      errors.imei = "IMEI is required";
    }
    if (!price || price === 0 || price === "") {
      errors.price = "Purchase price is required";
    } else {
      const priceStr = price.toString().replace(/[,\s]/g, '');
      const numPrice = parseFloat(priceStr);
      if (isNaN(numPrice) || numPrice <= 0) {
        errors.price = "Purchase price must be a valid number greater than 0";
      }
    }
    if (!quantity || quantityStr.trim() === "") {
      errors.quantity = "Sale price is required";
    } else {
      const qtyStr = quantityStr.replace(/[,\s]/g, '');
      const numQuantity = parseFloat(qtyStr);
      if (isNaN(numQuantity) || numQuantity <= 0) {
        errors.quantity = "Sale price must be a valid number greater than 0";
      }
    }
    return errors;
  };

  // Final submit validation
  const validateAllForSubmit = () => {
    const newErrors = {
      invoiceNumber: validateInvoiceNumber(invoiceNumber),
      date: validateDate(date),
      supplierName: validateSupplierName(supplierName),
      mobileNumber: validateMobileNumber(mobileNumber),
      tableData: tableData.length === 0 ? "At least one brand item must be added" : "",
    };

    setErrors(newErrors);
    return !newErrors.invoiceNumber && !newErrors.date && !newErrors.supplierName && 
           !newErrors.mobileNumber && !newErrors.tableData;
  };

  const [isDataChanged, setIsDataChanged] = useState(false);
  const navigate = useNavigate();
  const isReloadingRef = useRef(false);

  // Validation states
  const [errors, setErrors] = useState({
    invoiceNumber: "",
    date: "",
    supplierName: "",
    mobileNumber: "",
    // Brand Details
    modelName1: "",
    color: "",
    imei: "",
    price: "",
    quantity: "",
    // Final submit
    tableData: "",
  });
  const [touched, setTouched] = useState({
    date: false,
    supplierName: false,
    mobileNumber: false,
    modelName1: false,
    color: false,
    imei: false,
    price: false,
    quantity: false,
  });
  const [submitAttempted, setSubmitAttempted] = useState(false);

  // ..............................< Unsaved Navigation>...............................
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isDataChanged && !isReloadingRef.current) {
        const message = "You have unsaved changes. Are you sure you want to leave?";
        event.returnValue = message;
        return message;
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [isDataChanged]);

  // Callback function to handle navigation from the header
  const handleHeaderNavigation = () => {
    if (isDataChanged && !window.confirm("You have unsaved changes. Are you sure you want to leave?")) {
      // If there are unsaved changes and the user clicks cancel, prevent navigation
      return false;
    }
    return true; // Allow navigation
  };


  // ...........................<Cancle Model>.......................

  const cancelModel = () => {
    if (isDataChanged) {
      const confirmCancel = window.confirm('You have unsaved changes. Are you sure you want to cancel?');
      if (!confirmCancel) {
        return;
      }
    }

    setInvoiceNumber('');
    setDate(today);
    setSupplierName('');
    setMobileNumber('');
    setAddress('');
    setSubTotal(0);
    setBalance(0);
    setPayableAmount('');
    setPaymentMode('');
    setFile(null);

    // Clear Edit States
    setEditIndex(null);

    // Reset validation states
    setErrors({
      invoiceNumber: "",
      date: "",
      supplierName: "",
      mobileNumber: "",
      modelName1: "",
      color: "",
      imei: "",
      price: "",
      quantity: "",
      tableData: "",
    });
    setTouched({
      date: false,
      supplierName: false,
      mobileNumber: false,
      modelName1: false,
      color: false,
      imei: false,
      price: false,
      quantity: false,
    });
    setSubmitAttempted(false);
    setIsDataChanged(false);

    // Use the navigate function to redirect to another page
    // replace '/your-redirect-path' with the desired path
  };

  // const handleInputChange = (e) => {
  //   setInvoiceNumber(e.target.value);
  //   setIsDataChanged(true);
  // };

  //......................... [ Add Brand Details ]............................

  const addBrandDetails = async (e) => {
    e.preventDefault();

    // First check if Invoice Number is filled
    const invoiceStr = invoiceNumber ? invoiceNumber.toString() : "";
    if (!invoiceNumber || invoiceStr.trim() === "") {
      setErrors((prev) => ({
        ...prev,
        invoiceNumber: "Invoice number is required before adding brand details",
      }));
      toast.warning("Please wait for Invoice Number to be generated");
      return;
    }

    // Validate invoice number format
    const invoiceError = validateInvoiceNumber(invoiceNumber);
    if (invoiceError) {
      setErrors((prev) => ({
        ...prev,
        invoiceNumber: invoiceError,
      }));
      return;
    }

    // Validate brand details
    const brandErrors = validateBrandDetails();
    if (Object.keys(brandErrors).length > 0) {
      setErrors((prev) => ({ ...prev, ...brandErrors }));
      // Mark fields as touched
      setTouched((prev) => ({
        ...prev,
        modelName1: true,
        color: true,
        imei: true,
        price: true,
        quantity: true,
      }));
      return;
    }

    // Clear errors if validation passes
    setErrors((prev) => ({
      ...prev,
      modelName1: "",
      color: "",
      imei: "",
      price: "",
      quantity: "",
    }));

    // Clean price and quantity - remove commas and spaces
    const cleanPrice = price ? price.toString().replace(/[,\s]/g, '') : '';
    const cleanQuantity = quantity ? quantity.toString().replace(/[,\s]/g, '') : '';

    const item = {
      invoice_no: invoiceNumber ? invoiceNumber.toString() : "",
      mobile_no: mobileNumber ? mobileNumber.toString().trim() : "",
      model_name: modelName1 ? modelName1.toString().trim() : "",
      imei: imei ? imei.toString().trim() : "",
      purchase_price: cleanPrice,
      sale_price: cleanQuantity,
      color: color ? color.toString().trim() : "",
      purchase_type: "Purchase",
    };

    // Update existing item or add new item
    if (editIndex !== null) {
      // Update existing item in array
      setTableData((prevTableData) => {
        const newArray = [...prevTableData];
        newArray[editIndex] = item;
        console.log("Purchase Items Array Updated:", newArray);
        return newArray;
      });
      toast.success("Item updated successfully");
      setEditIndex(null);
    } else {
      // Add new item to state array (no API call - will save on final submit)
      setTableData((prevTableData) => {
        const newArray = [...prevTableData, item];
        console.log("Purchase Items Array:", newArray);
        return newArray;
      });
      toast.success("Item added to list");
    }

    // Clear the input fields
    setModelName1("");
    setModelName("");
    setImei("");
    setQuantity("");
    setPrice("");
    setColor("");

    // Reset touched states for brand fields
    setTouched((prev) => ({
      ...prev,
      modelName1: false,
      color: false,
      imei: false,
      price: false,
      quantity: false,
    }));

    // Sub Total will be calculated automatically by useEffect based on tableData
  };

  // Edit Brand Details item
  const handleEdit = (index) => {
    const item = tableData[index];
    if (item) {
      setEditIndex(index);
      setModelName1(item.model_name || "");
      setImei(item.imei || "");
      setPrice(item.purchase_price || "");
      setQuantity(item.sale_price || "");
      setColor(item.color || "");
      toast.info("Editing item. Make changes and click Add to update.");
    }
  };

  // Cancel edit for Brand Details
  const handleCancelEdit = () => {
    setEditIndex(null);
    setModelName1("");
    setModelName("");
    setImei("");
    setQuantity("");
    setPrice("");
    setColor("");
    setErrors((prev) => ({
      ...prev,
      modelName1: "",
      color: "",
      imei: "",
      price: "",
      quantity: "",
    }));
  };

  // Delete Record from state (no API call since items not saved yet)
  const handleDelete = (id, index) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this item from the list?"
    );

    if (confirmDelete) {
      // Remove from state array (items are not saved to DB until final submit)
      setTableData((preData) => preData.filter((_, i) => i !== index));
      toast.success("Item removed from list");
    }
  };

  //  ............................ [ Add All Purchase Details ].........................

  const addAllDetails = async () => {
    // Mark submit as attempted
    setSubmitAttempted(true);

    // Mark all supplier fields as touched
    setTouched((prev) => ({
      ...prev,
      date: true,
      supplierName: true,
      mobileNumber: true,
    }));

    // Validate all fields for final submit
    if (!validateAllForSubmit()) {
      return;
    }

    const data = new FormData();
    data.append("invoice_no", invoiceNumber ? invoiceNumber.toString().trim() : "");
    data.append("date", date);
    data.append("supplier_name", supplierName ? supplierName.toString().trim() : "");
    data.append("mobile_no", mobileNumber ? mobileNumber.toString().trim() : "");
    data.append("address", address ? address.toString().trim() : "");
    data.append("sub_total", subTotal);
    data.append("balance_amount", "0");
    data.append("payable_amount", "0");
    data.append("payment_mode", "NA");
    data.append("file", file);

    // Validate arrays before submit
    if (!tableData || tableData.length === 0) {
      toast.error("Please add at least one brand item before submitting");
      setErrors((prev) => ({ ...prev, tableData: "At least one brand item is required" }));
      return;
    }

    console.log("Submitting Purchase Data:");
    console.log("Purchase Details:", data);
    console.log("Purchase Items Array (tableData):", tableData);

    try {
      // Step 1: Save Purchase Details first
      console.log("Sending request with data:", data);

      const result = await fetch(`${apiUrl}/purchase_details`, {
        method: "POST",
        body: data,
      });

      console.log("Response from server:", result);

      // Parse response to get message
      let responseData = null;
      try {
        responseData = await result.json();
      } catch (e) {
        // Response might not be JSON
        console.log("Response is not JSON");
      }

      if (!result.ok) {
        // Try to get error message from response
        let errorMessage = "Failed to save purchase details";
        if (responseData) {
          errorMessage = responseData.message || responseData.error || responseData.msg || errorMessage;
        } else {
          // If response is not JSON, use status text
          errorMessage = result.statusText || errorMessage;
        }
        toast.error(errorMessage);
        return;
      }

      // If successful, check if there's a success message from API
      if (responseData && responseData.message) {
        console.log("API Success Message:", responseData.message);
      }

      // Step 2: Save all Purchase Items from tableData array
      if (tableData && tableData.length > 0) {
        console.log(`Saving ${tableData.length} Purchase Items from array...`);
        const purchaseItemsPromises = tableData.map(async (item, index) => {
          console.log(`Saving Purchase Item ${index + 1}:`, item);
          try {
            const response = await fetch(`${apiUrl}/purchase_items`, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
              },
              body: JSON.stringify(item),
            });
            
            // Parse response to get error message if failed
            let errorMessage = null;
            if (!response.ok) {
              try {
                const errorData = await response.json();
                errorMessage = errorData.message || errorData.error || errorData.msg || `Failed to save item ${index + 1}`;
              } catch (e) {
                errorMessage = response.statusText || `Failed to save item ${index + 1}`;
              }
            }
            
            return { success: response.ok, errorMessage, index: index + 1 };
          } catch (error) {
            return { success: false, errorMessage: error.message || `Failed to save item ${index + 1}`, index: index + 1 };
          }
        });

        const purchaseItemsResults = await Promise.all(purchaseItemsPromises);
        
        // Check each result and collect error messages
        const errors = purchaseItemsResults
          .filter(result => !result.success)
          .map(result => `Item ${result.index}: ${result.errorMessage}`);
        
        if (errors.length > 0) {
          // Show all error messages
          errors.forEach(error => {
            toast.error(error);
          });
          return;
        }
        console.log(`Successfully saved ${tableData.length} Purchase Items`);
      }

      // All data saved successfully
      toast.success("Purchase completed successfully");
      
      // Reload Supplier_pagination component
      setSupplierPaginationRefreshKey((prev) => prev + 1);

      // Clear all state
      setTableData([]);

      // Reset your state
      setInvoiceNumber("");
      setDate(today);
      setSupplierName("");
      setMobileNumber("");
      setAddress("");
      setSubTotal(0);
      setBalance(0);
      setPayableAmount("");
      setPaymentMode("");
      setFile(null);

      // Reset validation states
      setErrors({
        invoiceNumber: "",
        date: "",
        supplierName: "",
        mobileNumber: "",
        modelName1: "",
        color: "",
        imei: "",
        price: "",
        quantity: "",
        tableData: "",
      });
      setTouched({
        date: false,
        supplierName: false,
        mobileNumber: false,
        modelName1: false,
        color: false,
        imei: false,
        price: false,
        quantity: false,
      });
      setSubmitAttempted(false);
      
      // Set isDataChanged to false to prevent reload alert
      setIsDataChanged(false);
      isReloadingRef.current = true;
      
      // Reload the page after successful submission
      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (error) {
      console.error("Error:", error);
      // Show the actual error message if available
      const errorMessage = error.message || "Failed to save purchase. Please try again.";
      toast.error(errorMessage);
    }
  };






  // ..........................[ fetch Purchase Item ].............................

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_all_purchaseItems`);
        const data = await response.json();
        setTableData(data.data);

        console.log(data);
      } catch (error) {
        console.error(error);
      }
    };

    if (shouldFetchData) {
      fetchData();
    }
  }, [shouldFetchData]);

  // ..........................[ Calculate Sub Total from tableData ].............................

  useEffect(() => {
    if (tableData && tableData.length > 0) {
      const total = tableData.reduce((sum, item) => {
        const purchasePrice = parseFloat(item.purchase_price) || 0;
        return sum + purchasePrice;
      }, 0);
      setSubTotal(total);
    } else {
      setSubTotal(0);
    }
  }, [tableData]);

  //.......................[ fetch All Models ].............................

  const [modelList, setModelList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_all_models`);
        const data = await response.json();
        console.log(data)
        setModelList(data.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  // Function to handle model name selection
  const handleModelNameChange = (e) => {
    const selectmodeldataname = e.target.value;
    const selectedModelData = modelList.find(model => model.model_name === selectmodeldataname);

    if (selectedModelData) {
      setModelName1(selectedModelData.model_name);
      setColor(selectedModelData.color_name);
    } else {
      setModelName1(selectmodeldataname);
      // Don't clear color if user is typing
    }
    
    setIsDataChanged(true);
    
    // Validate on change if field has been touched
    if (touched.modelName1) {
      const modelNameStr = selectmodeldataname ? selectmodeldataname.toString() : "";
      setErrors((prev) => ({
        ...prev,
        modelName1: modelNameStr.trim() === "" ? "Model name is required" : "",
      }));
    }
  };

  const handleModelNameBlur = () => {
    setTouched((prev) => ({ ...prev, modelName1: true }));
    const modelNameStr = modelName1 ? modelName1.toString() : "";
    setErrors((prev) => ({
      ...prev,
      modelName1: modelNameStr.trim() === "" ? "Model name is required" : "",
    }));
  };

  const handleColorChange = (e) => {
    const v = capitalizeWords(e.target.value);
    setColor(v);
    setIsDataChanged(true);
    
    if (touched.color) {
      setErrors((prev) => ({
        ...prev,
        color: v.trim() === "" ? "Color is required" : "",
      }));
    }
  };

  const handleColorBlur = () => {
    setTouched((prev) => ({ ...prev, color: true }));
    const colorStr = color ? color.toString() : "";
    setErrors((prev) => ({
      ...prev,
      color: colorStr.trim() === "" ? "Color is required" : "",
    }));
  };

  const handleImeiChange = (e) => {
    const value = e.target.value.toUpperCase();
    setImei(value);
    setIsDataChanged(true);
    
    if (touched.imei) {
      setErrors((prev) => ({
        ...prev,
        imei: value.trim() === "" ? "IMEI is required" : "",
      }));
    }
  };

  const handleImeiBlur = () => {
    setTouched((prev) => ({ ...prev, imei: true }));
    const imeiStr = imei ? imei.toString() : "";
    setErrors((prev) => ({
      ...prev,
      imei: imeiStr.trim() === "" ? "IMEI is required" : "",
    }));
  };

  const handlePriceChange = (e) => {
    const value = e.target.value;
    setPrice(value);
    setIsDataChanged(true);
    
    if (touched.price) {
      const numPrice = parseFloat(value);
      if (!value || value === 0 || value === "") {
        setErrors((prev) => ({ ...prev, price: "Purchase price is required" }));
      } else if (isNaN(numPrice) || numPrice <= 0) {
        setErrors((prev) => ({ ...prev, price: "Purchase price must be a valid number greater than 0" }));
      } else {
        setErrors((prev) => ({ ...prev, price: "" }));
      }
    }
  };

  const handlePriceBlur = () => {
    setTouched((prev) => ({ ...prev, price: true }));
    const numPrice = parseFloat(price);
    if (!price || price === 0 || price === "") {
      setErrors((prev) => ({ ...prev, price: "Purchase price is required" }));
    } else if (isNaN(numPrice) || numPrice <= 0) {
      setErrors((prev) => ({ ...prev, price: "Purchase price must be a valid number greater than 0" }));
    } else {
      setErrors((prev) => ({ ...prev, price: "" }));
    }
  };

  const handleQuantityChange = (e) => {
    const value = e.target.value;
    setQuantity(value);
    setIsDataChanged(true);
    
    if (touched.quantity) {
      const numQuantity = parseFloat(value);
      if (!value || value.trim() === "") {
        setErrors((prev) => ({ ...prev, quantity: "Sale price is required" }));
      } else if (isNaN(numQuantity) || numQuantity <= 0) {
        setErrors((prev) => ({ ...prev, quantity: "Sale price must be a valid number greater than 0" }));
      } else {
        setErrors((prev) => ({ ...prev, quantity: "" }));
      }
    }
  };

  const handleQuantityBlur = () => {
    setTouched((prev) => ({ ...prev, quantity: true }));
    const quantityStr = quantity ? quantity.toString() : "";
    const numQuantity = parseFloat(quantityStr);
    if (!quantity || quantityStr.trim() === "") {
      setErrors((prev) => ({ ...prev, quantity: "Sale price is required" }));
    } else if (isNaN(numQuantity) || numQuantity <= 0) {
      setErrors((prev) => ({ ...prev, quantity: "Sale price must be a valid number greater than 0" }));
    } else {
      setErrors((prev) => ({ ...prev, quantity: "" }));
    }
  };


  //.....................................................................


  const [suppilerList, setSuppilerList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_all_supplier`);
        const data = await response.json();
        setSuppilerList(data.data);
        setInvoiceNumber(data.invoice_no);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const handleSupplierChange = (selectedSupplier) => {
    // Find the selected supplier from the supplier list
    const selectedSupplierInfo = suppilerList.find(
      (supplier) => supplier.supplier_name === selectedSupplier
    );

    // Update mobile number and address based on the selected supplier
    if (selectedSupplierInfo) {
      setMobileNumber(selectedSupplierInfo.contact || '');
      setAddress(selectedSupplierInfo.address || '');
    } else {
      setMobileNumber('');
      setAddress('');
    }

    // Update the selected supplier name
    setSupplierName(selectedSupplier);
    setIsDataChanged(true);
    
    // Validate on change if field has been touched or submit was attempted
    if (touched.supplierName || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        supplierName: validateSupplierName(selectedSupplier),
      }));
    }
  };

  const handleSupplierNameBlur = () => {
    setTouched((prev) => ({ ...prev, supplierName: true }));
    setErrors((prev) => ({
      ...prev,
      supplierName: validateSupplierName(supplierName),
    }));
  };

  const handleDateChange = (e) => {
    const value = e.target.value;
    setDate(value);
    setIsDataChanged(true);
    
    if (touched.date || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        date: validateDate(value),
      }));
    }
  };

  const handleDateBlur = () => {
    setTouched((prev) => ({ ...prev, date: true }));
    setErrors((prev) => ({
      ...prev,
      date: validateDate(date),
    }));
  };

  const handleMobileNumberChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 10);
    setMobileNumber(value);
    setIsDataChanged(true);
    
    if (touched.mobileNumber || submitAttempted) {
      setErrors((prev) => ({
        ...prev,
        mobileNumber: validateMobileNumber(value),
      }));
    }
  };

  const handleMobileNumberBlur = () => {
    setTouched((prev) => ({ ...prev, mobileNumber: true }));
    setErrors((prev) => ({
      ...prev,
      mobileNumber: validateMobileNumber(mobileNumber),
    }));
  };
  //.....................................................................

  //................................................................ [  fetch data using Mobile number  ] ..........................................

  // const fetchData = async () => {
  //   try {
  //     const response = await fetch(`${apiUrl}/get_all_purchaseDetails`);
  //     const data = await response.json();

  //     const filterData = data.data.filter(
  //       (item) => item.mobile_no === mobileNumber
  //     );
  //     console.log(filterData);

  //     console.log(filterData.length);
  //     const len = filterData.length;

  //     //.................................................. [ set Balance when mobile number is correct otherwise display 0 and print error msg] ...........................

  //     if (len > 0) {
  //       console.log(filterData[len - 1].balance_amount);
  //       console.log("Sum of Balance: " + filterData[len - 1].balance_amount);
  //       const balanceAmount =
  //         mobileNumber.length === 10 ? filterData[len - 1].balance_amount : 0;
  //       setBalance(balanceAmount);
  //       setImeiNotFound(balanceAmount === 0);
  //     } else if (mobileNumber.length > 0) {
  //       console.log("No matching purchase data found.");
  //       setBalance(0);
  //       setImeiNotFound(true);
  //     } else {
  //       console.log("Please enter a valid mobile number.");
  //     }

  //     //........................................................................................................................

  //     console.log(data);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // useEffect(() => {
  //   fetchData();
  // }, [mobileNumber]);


  //.....................................................................



  return (
    <>
      <ToastContainer autoClose="1500" />
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header onNavigate={handleHeaderNavigation} />


          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 pt-5">
                <div className="row">
                  <div className="col-md-7">
                    <h4 className="fw-bold  mb-4">Purchase Details</h4>
                  </div>
                  <div className="col-md-5">
                    <Supplier_pagination refreshKey={supplierPaginationRefreshKey} />
                  </div>
                </div>

                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 heading-heighlight">Supplier Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3" style={{ display: 'none' }}>
                        <label
                          className="form-label"
                          htmlFor="basic-default-fullname"
                        >
                          Invoice Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="basic-default-fullname"
                          placeholder="Enter Invoice Number"
                          readOnly
                          value={invoiceNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            setInvoiceNumber(value);
                          }}

                          required
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-date"
                        >
                          Date <span className="text-danger">*</span>
                        </label>
                        <input
                          type="date"
                          className={`form-control ${(touched.date && errors.date) || (submitAttempted && errors.date) ? 'is-invalid' : touched.date && !errors.date && date ? 'is-valid' : ''}`}
                          id="basic-default-date"
                          placeholder="Enter date"
                          value={date}
                          onChange={handleDateChange}
                          onBlur={handleDateBlur}
                          max={today}
                        />
                        {((touched.date && errors.date) || (submitAttempted && errors.date)) && (
                          <div className="invalid-feedback d-block">
                            {errors.date}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-supplier-name">
                          Supplier Name <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${(touched.supplierName && errors.supplierName) || (submitAttempted && errors.supplierName) ? 'is-invalid' : touched.supplierName && !errors.supplierName && supplierName ? 'is-valid' : ''}`}
                          list="supplierList"
                          id="basic-default-supplier-name"
                          placeholder="Enter Supplier Name"
                          value={supplierName}
                          onChange={(e) => handleSupplierChange(e.target.value)}
                          onBlur={handleSupplierNameBlur}
                          aria-label="Supplier Name"
                          aria-describedby="supplier-name-error"
                        />
                        <datalist id="supplierList">
                          {suppilerList.map((supplier, index) => (
                            <option key={index} value={supplier.supplier_name} />
                          ))}
                        </datalist>
                        {((touched.supplierName && errors.supplierName) || (submitAttempted && errors.supplierName)) && (
                          <div className="invalid-feedback d-block" id="supplier-name-error">
                            {errors.supplierName}
                          </div>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-mobile-number">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="basic-default-mobile-number"
                          className={`form-control phone-mask ${(touched.mobileNumber && errors.mobileNumber) || (submitAttempted && errors.mobileNumber) ? 'is-invalid' : touched.mobileNumber && !errors.mobileNumber && mobileNumber ? 'is-valid' : ''}`}
                          placeholder="Enter Mobile Number"
                          value={mobileNumber}
                          onChange={handleMobileNumberChange}
                          onBlur={handleMobileNumberBlur}
                          maxLength={10}
                        />
                        {((touched.mobileNumber && errors.mobileNumber) || (submitAttempted && errors.mobileNumber)) && (
                          <div className="invalid-feedback d-block">
                            {errors.mobileNumber}
                          </div>
                        )}
                        <small className="text-muted">
                          Enter 10 digit mobile number
                        </small>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-phone">
                          Address
                        </label>
                        <textarea
                          id="basic-default-message"
                          className="form-control"
                          placeholder="Enter Address"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          rows={1}
                        />
                      </div>
                      <hr className="mb-3 mt-3" />
                      <h5 className="mb-4 heading-heighlight">Brand Details</h5>

                      <div className="col-md-6 mb-3">
                        <div className="row">
                          <div className="col-md-12 mb-3">
                            <div className="row">
                              <div className="col-md-6 mb-3">
                                <label className="form-label" htmlFor="basic-default-model-name">
                                  Model Name <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${(touched.modelName1 && errors.modelName1) ? 'is-invalid' : touched.modelName1 && !errors.modelName1 && modelName1 ? 'is-valid' : ''}`}
                                  list="browsers"
                                  name="browser"
                                  id="basic-default-model-name"
                                  placeholder="Enter Model Name"
                                  value={modelName1}
                                  onChange={handleModelNameChange}
                                  onBlur={handleModelNameBlur}
                                />
                                <datalist id="browsers">
                                  {modelList.map((model, index) => (
                                    <option key={index} value={model.model_name} />
                                  ))}
                                </datalist>
                                {(touched.modelName1 && errors.modelName1) && (
                                  <div className="invalid-feedback d-block">
                                    {errors.modelName1}
                                  </div>
                                )}
                              </div>

                              <div className="col-md-6 mb-3">
                                <label
                                  className="form-label"
                                  htmlFor="basic-default-color"
                                >
                                  Color <span className="text-danger">*</span>
                                </label>
                                <input
                                  type="text"
                                  className={`form-control ${(touched.color && errors.color) ? 'is-invalid' : touched.color && !errors.color && color ? 'is-valid' : ''}`}
                                  id="basic-default-color"
                                  list="color-options"
                                  placeholder="Enter Color"
                                  value={color}
                                  onChange={handleColorChange}
                                  onBlur={handleColorBlur}
                                />
                                <datalist id="color-options">
                                  <option value="Black" />
                                  <option value="White" />
                                  <option value="Blue" />
                                  <option value="Yellow" />
                                  <option value="Coral" />
                                  <option value="RED" />
                                  <option value="Purple" />
                                  <option value="Green" />
                                  <option value="Starlight" />
                                  <option value="Midnight" />
                                  <option value="Pink" />
                                  <option value="Teal" />
                                  <option value="Ultramarine" />
                                  <option value="Mist Blue" />
                                  <option value="Sage" />
                                  <option value="Lavender" />
                                  <option value="Silver" />
                                  <option value="Space Gray" />
                                  <option value="Gold" />
                                  <option value="Midnight Green" />
                                  <option value="Graphite" />
                                  <option value="Pacific Blue" />
                                  <option value="Sierra Blue" />
                                  <option value="Alpine Green" />
                                  <option value="Space Black" />
                                  <option value="Deep Purple" />
                                  <option value="Black Titanium" />
                                  <option value="White Titanium" />
                                  <option value="Blue Titanium" />
                                  <option value="Natural Titanium" />
                                  <option value="Desert Titanium" />
                                  <option value="Cosmic Orange" />
                                  <option value="Deep Blue" />
                                </datalist>
                                {(touched.color && errors.color) && (
                                  <div className="invalid-feedback d-block">
                                    {errors.color}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-imei"
                        >
                          IMEI <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="basic-default-imei"
                          className={`form-control phone-mask ${(touched.imei && errors.imei) ? 'is-invalid' : touched.imei && !errors.imei && imei ? 'is-valid' : ''}`}
                          placeholder="Enter IMEI"
                          value={imei}
                          style={{ textTransform: 'uppercase' }}
                          onChange={handleImeiChange}
                          onBlur={handleImeiBlur}
                        />
                        {(touched.imei && errors.imei) && (
                          <div className="invalid-feedback d-block">
                            {errors.imei}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-purchase-price"
                        >
                          Purchase Price <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="basic-default-purchase-price"
                          className={`form-control phone-mask ${(touched.price && errors.price) ? 'is-invalid' : touched.price && !errors.price && price ? 'is-valid' : ''}`}
                          placeholder="Enter Purchase Price"
                          value={price}
                          onChange={handlePriceChange}
                          onBlur={handlePriceBlur}
                        />
                        {(touched.price && errors.price) && (
                          <div className="invalid-feedback d-block">
                            {errors.price}
                          </div>
                        )}
                        <small className="text-muted">
                          Enter amount (e.g., 1000 or 1000.50)
                        </small>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-sale-price"
                        >
                          Sale Price <span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          id="basic-default-sale-price"
                          className={`form-control phone-mask ${(touched.quantity && errors.quantity) ? 'is-invalid' : touched.quantity && !errors.quantity && quantity ? 'is-valid' : ''}`}
                          placeholder="Enter Sale Price"
                          value={quantity}
                          onChange={handleQuantityChange}
                          onBlur={handleQuantityBlur}
                        />
                        {(touched.quantity && errors.quantity) && (
                          <div className="invalid-feedback d-block">
                            {errors.quantity}
                          </div>
                        )}
                        <small className="text-muted">
                          Enter amount (e.g., 1000 or 1000.50)
                        </small>
                      </div>
                      <div className="col-12">
                        <div className="col-12 d-flex justify-content-end">
                          {editIndex !== null && (
                            <button
                              type="button"
                              className="btn btn-secondary"
                              style={{ marginLeft: "5px", marginRight: "5px" }}
                              onClick={handleCancelEdit}
                            >
                              Cancel
                            </button>
                          )}
                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{ marginLeft: "5px", marginRight: "5px" }}
                            onClick={addBrandDetails}
                          >
                            {editIndex !== null ? "Update" : "Add"}
                          </button>
                        </div>
                        {tableData.length > 0 ? (
                          <div className="card mt-3">
                            <h5 className="card-header heading-heighlight">Brand List</h5>
                            <div className="table-responsive text-nowrap">
                              <table className="table">
                                <thead>
                                  <tr className="text-nowrap">
                                    <th>SN</th>
                                    <th>Model Name</th>
                                    <th>Color</th>
                                    <th>IMEI</th>
                                    <th>Purchase Price</th>
                                    <th>Sale Price</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {tableData.map((row, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{row.model_name}</td>
                                      <td>{row.color}</td>
                                      <td>{row.imei}</td>
                                      <td>{row.purchase_price}</td>
                                      <td>{row.sale_price}</td>
                                      <td>
                                        <button
                                          type="button"
                                          className="btn btn-primary btn-sm me-1"
                                          onClick={() => handleEdit(index)}
                                          style={{ marginRight: "5px" }}
                                          title="Edit"
                                        >
                                          <FaEdit />
                                        </button>
                                        <button
                                          type="button"
                                          className="btn btn-danger btn-sm"
                                          onClick={() => handleDelete(row.id, index)}
                                          title="Delete"
                                        >
                                          <FaTrashAlt />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        ) : (
                          <div className=""></div>
                        )}
                      </div>
                      <hr className="mb-3 mt-3" />
                      <h5 className="mb-4 heading-heighlight">Payment Details</h5>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-company"
                        >
                          Sub Total
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Sub Total"
                          value={subTotal}
                          readOnly
                        />
                      </div>

                      {/* <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          Payable Amount
                        </label>
                        <input
                          type="number"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Payable Amount"
                          value={payableAmount}
                          onChange={(e) => setPayableAmount(e.target.value)}
                        />
                      </div> */}
                      {/* <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-company"
                        >
                          Balance
                        </label>
                        <input
                          type="number"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Balance"
                          value={
                            (balance =
                              Number(balance) +
                              Number(subTotal) -
                              Number(payableAmount))
                          }
                          onChange={(e) => setBalance(e.target.value)}
                        />
                      </div> */}
                      {/* <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          Payment Mode
                        </label>
                        <select
                          className="form-select"
                          id="basic-default-company"
                          defaultValue=""
                          value={paymentMode}
                          onChange={(e) => setPaymentMode(e.target.value)}
                        >
                          <option value="" disabled>
                           Select Payment Mode
                          </option>
                          <option value="Gpay">Gpay</option>
                          <option value="Phonepay">Phonepay</option>
                          <option value="Debit Card">Debit Card</option>

                          <option value="UPI">UPI</option>
                        </select>
                      </div> */}
                      <div className="col-md-6 mb-3">
                        <label className="form-label" htmlFor="basic-default-phone">
                          Upload File
                        </label>
                        <input
                          type="file"
                          id="basic-default-phone"
                          className="form-control"
                          onChange={(e) => setFile(e.target.files[0])}
                        />
                      </div>

                      {submitAttempted && errors.tableData && (
                        <div className="col-12 mb-3">
                          <div className="alert alert-danger" role="alert">
                            {errors.tableData}
                          </div>
                        </div>
                      )}
                      <div className="col-12 d-flex justify-content-end">
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{ marginLeft: "5px", marginRight: "5px" }}
                          onClick={addAllDetails}
                        >
                          Submit
                        </button>
                        <button type="button" className="btn btn-danger" onClick={cancelModel}>
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
